import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../../services/AxiosInstance";
import CustomSelect from "../../../Forms/Element/CustomSelect";

/**
 * Exibe as categorias do produto.
 */
const CardFlagSelect = (props) => {
   
    const { t } = useTranslation();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        axiosInstance.get("/main/card-flags", null).then((response) => {
            let options = [];

            for (var i = 0; i < response.data.length; i++) {
                options.push(
                    {
                        value: response.data[i].id,
                        label: response.data[i].name
                    }
                );

                setOptions(options);
            }
        });
    }, []);

    return (
        <CustomSelect
            options={options}
            placeholder={t("select")}
            {...props} />
    )
}

export default CardFlagSelect;